import type { RouteRecordRaw } from 'vue-router';
import { UserRole, PermissionAction } from './roles';
import { RolePermissionConfig } from './permissions';

export function hasRoutePermission(userRole: UserRole | null | undefined, route: RouteRecordRaw): boolean {

  // console.log(`角色 ${userRole} 不在权限配置中，拒绝访问路由`);
  const routeName = route.name as string;
  if (!routeName) return true;

  if (route.meta?.requiresAuth === false) {
    return true;
  }

  if (!userRole) return false;

  const permissions = RolePermissionConfig[userRole];

  console.warn(`角色 ${userRole} 不在权限配置中，拒绝访问路由: ${routeName}`);
  if (!permissions) {
    console.warn(`角色 ${userRole} 不在权限配置中，拒绝访问路由: ${routeName}`);
    return false;
  }

  const showPermission = `${routeName}:${PermissionAction.SHOW}`;
  return permissions.includes(showPermission as any);
}

function findRouteByPath(routes: RouteRecordRaw[], path: string): RouteRecordRaw | null {
  for (const route of routes) {
    const routePath = route.path.startsWith('/') ? route.path : `/${route.path}`;
    if (routePath === path) {
      return route;
    }
    if (route.children) {
      const childRoute = findRouteByPath(route.children, path);
      if (childRoute) return childRoute;
    }
  }
  return null;
}

export { findRouteByPath };
